import axios from 'axios'
import _get from 'lodash/get'

import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const REQUEST_REFERRALS = 'REQUEST_REFERRALS'
export const RECEIVE_REFERRALS = 'RECEIVE_REFERRALS'
export const SEND_REFERRAL_EMAIL = 'SEND_REFERRAL_EMAIL'

/** @deprecated prefer using the `useReferrals` hook */
export const requestReferrals = () => (dispatch, getState) => {
    dispatch({ type: REQUEST_REFERRALS })

    const { profile } = getState()

    const { id: userId } = profile

    axios
        .get(`/user/${userId}/referrals`)
        .then((response) => {
            const items = _get(response, ['data'], [])

            dispatch(receiveReferrals({ items, fetchSuccessful: true }))
        })
        .catch((error) => {
            dispatch(receiveReferrals({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveReferrals = (data) => ({ type: RECEIVE_REFERRALS, data })

/** @deprecated prefer `useSendReferralEmail` hook */
export const sendReferralEmail = (emailAddress) => (dispatch) => {
    dispatch({ type: SEND_REFERRAL_EMAIL, data: { emailAddress } })

    return axios
        .post('/referral/email', { emailAddress })
        .then(() => {
            dispatch(receiveSuccessAlert('Invite has been sent. Invite more, earn more.'))
        })
        .catch((error) => {
            dispatch(
                handleRequestError(error, {
                    customMessage: 'There was a problem sending the email, please check the address or try again later',
                    hideAlert: true,
                })
            )

            return Promise.reject(error)
        })
}
